import React, { useState } from 'react'
import PropTypes from 'prop-types'

import useStyles from './image.style'

const Image = (props) => {
  const {
    src,
    alt,
    className,
    onClick,
    modal,
    style
  } = props

  const classes = useStyles(props)
  const [isOpen, setIsOpen] = useState(false)

  const handleClick = (e) => {
    if (modal) {
      setIsOpen(!isOpen)
    } else if (onClick) {
      return onClick()
    }

    return false
  }

  return (
    <div className={classes.wrapper}>
      <img
        alt={alt}
        className={className}
        onClick={handleClick}
        src={src}
        style={style}
      />
      {isOpen &&
        <div
          className={classes.imageModal}
          role='presentation'
        >
          
          <img
            alt={alt}
            className={classes.modalImage}
            onClick={handleClick}
            src={src}
            style={style}
          />
        </div>}
    </div>
  )
}

Image.defaultProps = {
  alt: '',
  className: '',
  modal: false,
  onClick: () => {},
  src: ''
}

Image.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  modal: PropTypes.bool,
  onClick: PropTypes.func,
  src: PropTypes.string
}

export default Image
